

































































import Vue from 'vue'
import Component from 'vue-class-component'
import ModalComponent from '@/components/modal/ModalComponent.vue'
import {ColorTheme, CriterionModel, CriterionTypeCode, EditCriterionRequestModel, StatusType} from '@/services/types'
import {StoreActionTypes} from '@/store/types'
import { IconDefinition, faEllipsisV } from '@fortawesome/free-solid-svg-icons'
import * as utils from '@/services/utils'
import ConfirmationComponent from '@/components/modal/ConfirmationComponent.vue'
import EditCriterionModalForm from '@/components/form/EditCriterionModalForm.vue'

@Component({
    components: {
        ModalComponent,
        ConfirmationComponent,
        EditCriterionModalForm
    }
})
export default class GridComponent extends Vue {
    private componentClass = "GridComponent"

    private fields = [
        { key: 'name', sortable: true, label: 'Наименование', tdClass: 'name-td', thClass: 'name-th' },
        { key: 'typeCode', sortable: true, label: 'Тип'},
        { key: 'status', sortable: true, label: 'Статус', tdClass: 'status-td', thClass: 'status-th' },
        { key: 'action', label: '', sortable: false, tdClass: 'action-td', thClass: 'action-th' }               
    ]

    private showEditCriterionForm = false 
    private ellipsis: IconDefinition = faEllipsisV
    private selectedCriterionId = null;

    private deleteCriterionConfirmationShow = false
    private changeStatusCriterionConfirmationShow = false
    private editedCriterionId: number | null = null

    get listItems(): CriterionModel [] {
        return this.$store.getters.getCriterionsFilteredList
    }

    getStatus(status: StatusType) {
        return status == 'ACTIVE' ? 'Активна' : 'Деактивирована'
    }

    getTypeCode(code: CriterionTypeCode) {
        return utils.getCriterionTypeCode(code)
    }

    getChangeStatusItemTitle(status: StatusType) {
        return status == 'ACTIVE' ? 'Деактивировать' : 'Активировать'
    }

    handleEditCriterionBtnClick(id: number) {      
        this.$store.dispatch(StoreActionTypes.SET_CRITERIONS_SELECTED_CRITERION_CLEAR)  
        this.selectedCriterionId = id
        this.showEditCriterionForm = !this.showEditCriterionForm
    }

	async handleEditCriterionModalOkBtnClick() {
        const model: EditCriterionRequestModel = (this.$refs.editCriterionForm as EditCriterionModalForm).getEditCriterionRequestModel()  
        await this.$store.dispatch(StoreActionTypes.SET_CRITERIONS_CRITERION_EDIT, model)
        await this.$store.dispatch(StoreActionTypes.SET_CRITERIONS_LIST_BY_CATEGORY_ID, model)            
        this.handleEditCriterionBtnClick(null)
    }

	get editedCriterionDisabled (){
        return this.$store.getters.isCriterionsDataLoading
    }

    get getCriterionName() {
        if (this.listItems.length > 0 && this.selectedCriterionId) {
            return this.listItems.find(item => item.id == this.selectedCriterionId).name
        }
        else {
            return ''
        }        
    }

    handleChangeStatusItemClick(id: number) {
        this.editedCriterionId = id
        this.changeStatusCriterionConfirmationShow = true
    }

    handleDeleteItemClick(id: number) {
        this.editedCriterionId = id
        this.deleteCriterionConfirmationShow = true
    }

    get getEditedCriterionName() {
        return this.listItems.length > 0 && this.listItems.find(item => item.id == this.editedCriterionId) ? this.listItems.find(item => item.id == this.editedCriterionId).name : ''
    }

    async deleteCriterion() {
        await this.$store.dispatch(StoreActionTypes.SET_CRITERIONS_CRITERION_DELETE, {
            ids: [this.editedCriterionId]
        })

        await this.$store.dispatch(StoreActionTypes.SET_CRITERIONS_LIST_BY_CATEGORY_ID)

        this.deleteCriterionCancel()
    }

    deleteCriterionCancel() {
        console.log('deleteCriterionCancel')
        this.editedCriterionId = null
        this.deleteCriterionConfirmationShow = false
    }

    changeCriterionStatusCancel() {
        this.editedCriterionId = null
        this.changeStatusCriterionConfirmationShow = false
    }

    getEditedCriterionStatus() {
        return this.listItems.length > 0 && this.listItems.find(item => item.id == this.editedCriterionId) ? this.listItems.find(item => item.id == this.editedCriterionId).status : null
    }

    get getEditedCriterionOkTitle() {
        return this.getChangeStatusItemTitle(
            this.getEditedCriterionStatus()
        )
    }

    async changeCriterionStatus() {
        await this.$store.dispatch(StoreActionTypes.SET_CRITERIONS_CRITERION_CHANGE_STATUS, {
                id: this.editedCriterionId, 
                status: this.getEditedCriterionStatus()
            })

        await this.$store.dispatch(StoreActionTypes.SET_CRITERIONS_LIST_BY_CATEGORY_ID)

        this.changeCriterionStatusCancel()
    }

    get setChangeStatusConfirmationOkBtnVariant() {
        return this.getOkBtnVariant(
            this.getEditedCriterionStatus()
        )
    }
    
    getOkBtnVariant(status: StatusType): ColorTheme {
        return status == 'ACTIVE' ? 'danger' : 'success'
    }
}
